/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {
  Modal,
  Box,
  Grid,
  List,
  ListItem,
  ListItemText,
  Button,
} from '@mui/material';

import useStyles from '../../../assets/styles/pages/ShopRequest';

import { ReactComponent as IconLocation } from '../../../assets/images/svg/shops/request/icon_local.svg';
import { ReactComponent as IconPlus } from '../../../assets/images/svg/shops/request/icon_mais1.svg';
import { ReactComponent as IconCashBack } from '../../../assets/images/svg/user/cashback.svg';
import { ReactComponent as IconRight } from '../../../assets/images/svg/shops/request/Vector.svg';

interface ExtraItem {
  key?: string | number;
  primary: string;
  onClick: () => void;
  icon?: React.ReactNode;
}

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  dataList: any[];
  type: 'endereco' | 'pagamento' | 'cupom' | 'custom' | 'bairros';
  onSelect: (item: any) => void;
  showAddButton?: boolean;
  onAddNew?: () => void;
  extraTopItem?: ExtraItem;
  extraBottomItem?: ExtraItem;
}

const styleModal = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 680,
  borderRadius: 8,
  bgcolor: 'background.paper',
  boxShadow: 24,
  outline: 'none',
};

export const ListCenterOrder = ({
  open,
  onClose,
  title,
  dataList,
  type,
  onSelect,
  showAddButton = false,
  onAddNew,
  extraTopItem,
  extraBottomItem,
}: Props): JSX.Element => {
  const classeStyle = useStyles();

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={styleModal}>
        <Grid
          container
          item
          xs={12}
          justifyContent="center"
          className={classeStyle.gridModalTop}
        >
          <h4 className={classeStyle.titleModalTop}>{title}</h4>
        </Grid>

        {dataList?.length > 0 && (
          <Grid padding="0px 15px">
            <Box sx={{ width: '100%', height: 350 }}>
              <List
                sx={{
                  width: '100%',
                  bgcolor: 'background.paper',
                  overflow: 'auto',
                  maxHeight: 350,
                  '& ul': { padding: 0 },
                }}
                subheader={<li />}
              >
                {extraTopItem && (
                  <li key={extraTopItem.key ?? 'extra-top'}>
                    <ul>
                      <ListItem
                        onClick={() => {
                          extraTopItem.onClick();
                        }}
                        className={classeStyle.gridNameModal}
                      >
                        <ListItemText
                          className={classeStyle.nameModal}
                          primary={extraTopItem.primary}
                        />
                        {extraTopItem.icon}
                      </ListItem>
                    </ul>
                  </li>
                )}
                {dataList.map((item: any) => (
                  <li
                    key={
                      item.idEndereco ||
                      item.idPagamento ||
                      item.idCupom ||
                      item.idBairro
                    }
                  >
                    <ul style={{ borderBottom: 'solid 1px #DFDFDF' }}>
                      <ListItem
                        onClick={() => onSelect(item)}
                        className={classeStyle.gridNameModal}
                      >
                        {type === 'endereco' && (
                          <>
                            <Grid
                              item
                              xs={2}
                              sm={1}
                              className={classeStyle.gridIconLocation}
                            >
                              <IconLocation />
                            </Grid>
                            <Grid item xs={10} sm={11}>
                              <ListItemText
                                className={classeStyle.nameModal}
                                primary={`${item.dsRua} ${item.nrRua} ${item.dsComplemento}`}
                                secondary={`${item.dsCidade}`}
                              />
                            </Grid>
                          </>
                        )}
                        {type === 'pagamento' && (
                          <>
                            <ListItemText
                              className={classeStyle.nameModal}
                              style={{ textAlign: 'center' }}
                              primary={`${item.dsPagamento}`}
                            />
                            {item.isCashback == 1 && <IconCashBack />}
                          </>
                        )}
                        {type === 'cupom' && (
                          <>
                            <ListItemText
                              className={classeStyle.nameModal}
                              primary={`${item.dsCupom}`}
                              secondary={item.dsMensagem || ''}
                            />
                            <IconRight width={15} height={15} />
                          </>
                        )}

                        {type === 'custom' && (
                          <ListItemText
                            className={classeStyle.nameModal}
                            primary={item.primary || item.name || item.title}
                          />
                        )}

                        {type === 'bairros' && (
                          <ListItemText
                            className={classeStyle.nameModal}
                            primary={item.dsBairro}
                          />
                        )}
                      </ListItem>
                    </ul>
                  </li>
                ))}
                {extraBottomItem && (
                  <li key={extraBottomItem.key ?? 'extra-bottom'}>
                    <ul>
                      <ListItem
                        onClick={() => {
                          extraBottomItem.onClick();
                        }}
                        className={classeStyle.gridNameModal}
                      >
                        <ListItemText
                          className={classeStyle.nameModal}
                          primary={extraBottomItem.primary}
                        />
                        {extraBottomItem.icon}
                      </ListItem>
                    </ul>
                  </li>
                )}
              </List>
            </Box>
          </Grid>
        )}

        {showAddButton && (
          <Grid
            container
            item
            xs={12}
            justifyContent="center"
            marginBottom="20px"
          >
            <Button
              className={classeStyle.btnModal}
              variant="contained"
              onClick={onAddNew}
            >
              Novo endereço <IconPlus className={classeStyle.iconArrow} />
            </Button>
          </Grid>
        )}
      </Box>
    </Modal>
  );
};
